import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { getSolutionThumbnail, getSolutionName, getSolutionShortDescription, getSolutionEnglishName, getSolutionId } from "template-store/services/solution-data-service";
import { getSolutionPageLink } from "template-store/services/solution-links-service";
import { SOLUTION_CARD_CLICKED } from "/constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import CardsComponent from "./cards-component/cards-component";
import { StyledTemplateList } from "./template-list.scss";
const TemplateList = (props)=>{
    const { solutions, title, context, translate } = props;
    const onCardClicked = useCallback((solution)=>{
        const solutionId = getSolutionId(solution);
        const solutionEnglishName = getSolutionEnglishName(solution);
        trackEvent(SOLUTION_CARD_CLICKED, {
            kind: solutionId,
            info1: solutionEnglishName,
            info2: context
        });
        window.location = getSolutionPageLink(solutionId, solutionEnglishName);
    }, [
        context
    ]);
    const cardsData = useMemo(()=>{
        return solutions.map((solution)=>{
            const solutionId = getSolutionId(solution);
            const solutionEnglishName = getSolutionEnglishName(solution);
            return {
                thumbnailUrl: getSolutionThumbnail(solution.data),
                description: getSolutionShortDescription(solution.data),
                title: getSolutionName(solution.data),
                pageUrl: getSolutionPageLink(solutionId, solutionEnglishName),
                onClick: ()=>onCardClicked(solution)
            };
        });
    }, [
        onCardClicked,
        solutions
    ]);
    return /*#__PURE__*/ _jsx(StyledTemplateList, {
        className: "template-list-component",
        children: /*#__PURE__*/ _jsx("div", {
            className: "template-list-items",
            children: /*#__PURE__*/ _jsx(CardsComponent, {
                title: title,
                cardItems: cardsData,
                showMoreText: translate("templateCenter.cards.showMore"),
                showLessText: translate("templateCenter.cards.showLess")
            })
        })
    });
};
export default withGenericConfig(TemplateList);
